import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { MemberListService } from '../../services/memberlist.service';
import { NewmemberService } from '../../services/newmember.service';

@Component({
  selector: 'app-membership-initiated',
  templateUrl: './membership-initiated.component.html',
  styleUrls: ['./membership-initiated.component.css']
})
export class MembershipInitiatedComponent implements OnInit {

  appNumber: any = null;
  constructor(public translateService: TranslateService,
              public router: Router,
              public newmemberService: NewmemberService,
              private confirmationService: ConfirmationService) {
  }

  ngOnInit() {
    this.translateService.use(localStorage.getItem('userPrefLang'));
    this.appNumber = localStorage.getItem('applicationNbr');
    setTimeout(() => {
      window.open('https://www.bestprice.in', '_self');
    }, 15000);
  }

  confirm(): void {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to perform this action?',
      accept: () => {
        this.router.navigateByUrl('/');
      },
      reject: () => {
      }
    });
  }

}
